import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useSelector } from 'react-redux';
import AuthorizedLayout from '../../shared/layout/AuthorizedLayout';
import { useStyles } from './styles';
import { MeditationContent } from './meditation-content';
import { ExercisesContent } from './exercises-content';
import { colors } from '../../../style/colors';
import { useAppConfiguration } from '../../shared/hook';
import { selectContentLibrary } from '../../../store';

export const TabPanel = (props: any) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
};

export const ContentLibrary = () => {
  const { withUnlimitedCredits } = useAppConfiguration();
  const classes = useStyles({ withUnlimitedCredits });
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);
  const handleChangeValue = (event: any, newValue: any) => {
    setValue(newValue);
  };
  const { exercises, meditations } = useSelector(selectContentLibrary);

  return (
    <AuthorizedLayout title="Exercices">
      <Box className={classes.mainContainer}>
        <Box className={classes.contentContainer}>
          <Typography variant="h2">
            {t('v2.exercises.header_label_title')}
          </Typography>
          <Typography className={classes.contentTopDescription}>
            {t('v2.exercises.header_label_subtitle')}
          </Typography>
          <Box style={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChangeValue}
              aria-label="basic tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: colors.darkestBlue,
                  height: 4,
                },
              }}
            >
              <Tab
                className={classes.tabLabel}
                label={t('v2.exercises.tabMenu_label_audioExercises')}
                {...a11yProps(0)}
              />
              <Tab
                className={classes.tabLabel}
                label={t('v2.exercises.tabMenu_label_meditations')}
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <ExercisesContent exercisesList={exercises} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <MeditationContent meditationList={meditations} />
          </TabPanel>
        </Box>
      </Box>
    </AuthorizedLayout>
  );
};
